import WriterEditor from '../WriterEditor';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { articlePayloadAtom } from '../../components/CreateArticle/atom';
import { initialStateArticle } from '../../components/CreateArticle/atom/initialState';
import {
  contributorAtom,
  hashtagAtom
} from '../../components/Common/Form/textarea-custom-hook-form/atom';
import useParsedQueryString from '../../hooks/router/useParsedQueryString';
import SEO from '../../components/SEO';
import { generateSEOMetadata, dynamicPages } from '../../utils/seo';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import {
  collapseDesktopAtom,
  sidebarCollapsedAtom
} from '../../components/Lexical/plugins/TableOfContentsPlugin/atom';

const CreateArticle = () => {
  const [, setArticlePayload] = useAtom(articlePayloadAtom);
  const [, setContributors] = useAtom(contributorAtom);
  const [, setHashtag] = useAtom(hashtagAtom);
  const [collapseDesktop] = useAtom(collapseDesktopAtom);
  const [sidebarCollapsed] = useAtom(sidebarCollapsedAtom);

  const queryParams = useParsedQueryString();
  const storyId = queryParams.storyId;
  const perspectiveGroupId = queryParams.perspectiveGroupId;
  const perspectiveGroupSlug = queryParams.perspectiveGroupSlug;
  const perspectiveGroupTitle = queryParams.perspectiveGroupTitle
    ? decodeURIComponent(queryParams.perspectiveGroupTitle)
    : null;

  useEffect(() => {
    setArticlePayload({
      ...initialStateArticle,
      ...(storyId && { storyId }),
      ...(perspectiveGroupId && { newsEventGroupId: perspectiveGroupId })
    });
    setContributors([]);
    setHashtag([]);
  }, [storyId, perspectiveGroupId, setArticlePayload, setContributors, setHashtag]);

  const seoMetadata = generateSEOMetadata.dynamicPage(
    dynamicPages['article/create'].name,
    dynamicPages['article/create'].url,
    dynamicPages['article/create'].description
  );

  return (
    <div>
      <SEO {...seoMetadata} />
      {perspectiveGroupTitle && (
        <div
          className={`bg-green-50 border-b border-green-200 px-6 py-3 flex items-center gap-3 transition-all duration-300 ${collapseDesktop ? 'md:ml-[80px]' : 'md:ml-[256px]'} ${sidebarCollapsed ? 'md:mr-[52px]' : 'md:mr-[520px]'}`}
        >
          <Link
            to={`/perspectives/${perspectiveGroupSlug || ''}`}
            className="text-green-600 hover:text-green-700 flex items-center gap-1 text-sm font-medium"
          >
            <ArrowLeft size={14} />
            Back
          </Link>
          <div className="h-4 w-px bg-green-300" />
          <div className="text-sm text-green-800 min-w-0">
            <span className="font-semibold">Writing a community perspective for:</span>{' '}
            <Link
              to={`/perspectives/${perspectiveGroupSlug || ''}`}
              className="text-green-700 hover:underline font-bold truncate"
            >
              {perspectiveGroupTitle}
            </Link>
          </div>
        </div>
      )}
      <WriterEditor />
    </div>
  );
};

export default CreateArticle;
